import type { ExceptionLog } from '../../data/exception-log';
import type { Product } from '../../data/product';
import { defineColumn, type StrictColumnDef } from '../tanstack-table/column';

type ProductLookup = (log: ExceptionLog) => Product | undefined;

export function wrapProductColumn(
  col: StrictColumnDef<Product>,
  findProduct: ProductLookup
): StrictColumnDef<ExceptionLog> {
  return defineColumn<ExceptionLog>({
    id: col.id,
    minWidth: col.meta.minWidth,
    maxWidth: col.meta.maxWidth,
    accessorFn: (log) => {
      const product = findProduct(log);

      return product ? col.meta.toString(product) : '';
    },
  });
}
